import { create } from "zustand";

interface Store {
  listMap: Record<string, any[]>;
  setMap(api: string, data: any[]): void;
  getList<T>(api: string): T[];
}
export const useListDataScore = create<Store>((set, get) => {
  return {
    listMap: {},
    setMap(api: string, data: any[]) {
      const listMap = { ...get().listMap };
      listMap[api] = data;
      set({ listMap });
    },
    getList<T>(api: string): T[] {
      return get().listMap[api] ?? [];
    },
  }
})